/**
 * @generated SignedSource<<b4c49942b30e159ef60890f6611c4be3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storeCatalogPaginationFragment__merchantProducts$data = {
  readonly merchantProducts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isConfiguratedInZakeke: boolean;
        readonly name: string;
        readonly sku: string;
        readonly thumbnail: string | null;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "storeCatalogPaginationFragment__merchantProducts";
};
export type storeCatalogPaginationFragment__merchantProducts$key = {
  readonly " $data"?: storeCatalogPaginationFragment__merchantProducts$data;
  readonly " $fragmentSpreads": FragmentRefs<"storeCatalogPaginationFragment__merchantProducts">;
};

import storeCatalogPaginationFragmentQuery_graphql from './storeCatalogPaginationFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "merchantProducts"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesChannelID"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": storeCatalogPaginationFragmentQuery_graphql
    }
  },
  "name": "storeCatalogPaginationFragment__merchantProducts",
  "selections": [
    {
      "alias": "merchantProducts",
      "args": [
        {
          "kind": "Variable",
          "name": "salesChannelID",
          "variableName": "salesChannelID"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "MerchantProductsConnection",
      "kind": "LinkedField",
      "name": "__storeCatalogPaginationFragment_merchantProducts_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MerchantProductsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MerchantProduct",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sku",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumbnail",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isConfiguratedInZakeke",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a79bdc4d935831a1c3c0511efe0f9fad";

export default node;
